<template>
  <v-card>
    <v-data-table
      :headers="headers"
      :items="cashshifts"
      :items-per-page="15"
      dense
      item-key="guid"
      elevation="0"
    >
      <template v-slot:top>
        <v-toolbar flat class="mb-5">
          <v-toolbar-title>Кассовая смена {{ department.name }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            color="orange darken-3"
            icon
            outlined
            small
            @click="$emit('close')"
            class="mr-5"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:item.events_error_count="{ item }">
        <v-icon :color=" item.events_error_count ? 'red' : 'green'">
          {{ item.events_error_count ? 'mdi-close' : 'mdi-check' }}
        </v-icon>
      </template>
      <template v-slot:item.is_night="{ item }">
        <v-btn small :color="item.is_night ? 'indigo darken-2' : 'blue lighten-3'">
          {{item.is_night ? 'Ночь' : 'День'}}
        </v-btn>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn icon outlined small color="primary" @click="getData(item)">
          <v-icon>
            mdi-account-multiple
          </v-icon>
        </v-btn>

      </template>
    </v-data-table>
    <DepartmentCashshiftEventsTable
      v-if="selectedCashshiftEvents"
      :events="selectedCashshiftEvents"
      v-on:close="selectedCashshiftEvents=null"
    />
  </v-card>
</template>

<script>
import DepartmentCashshiftEventsTable from "@/components/departments/DepartmentCashshiftEventsTable";

export default {
  name: "DepartmentCashshiftsTable",
  props: {
    department: Object,
    cashshifts: Array
  },
  components: {DepartmentCashshiftEventsTable},
  data: () => ({
    headers: [
      {text: "День", align: "center", value: "date"},
      {text: "Касса", align: "center", value: "pay_orders"},
      {text: "Количество явок", align: "center", value: "events_count"},
      {text: "Ошибок", align: "center", value: "events_error_count"},
      {text: "Заработали за день", align: "center", value: "total_sum"},
      {text: "Ночь", align: "center", value: "is_night"},
      {text: "", align: "center", value: "actions"},
    ],
    selectedCashshiftEvents: null,
    selectedCashshift: null
  }),
  mounted() {
    this.$root.$refs['cashshiftTable'] = this
  },
  methods: {
    getData(item = null) {
      if (!item) {
        this.$root.$refs.departmentTable.viewDepartmentCashshifts()
      }
      if (!item && !this.selectedCashshift) return
      this.$api.getEventsByCashshiftId({cashshift_id: item ? item.id : this.selectedCashshift.id, night: item.is_night},)
        .then(response => {
          this.selectedCashshift = item ? item : this.selectedCashshift
          this.selectedCashshiftEvents = response.data
        })
    }
  }
}
</script>

<style scoped>

</style>